var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "account_settings_tab" } }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-top" },
      [
        _c("div", { staticClass: "bb-settings-guide" }, [
          _c("div", { staticClass: "settings-business-info-guide" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm.$t("accountTab.guide.businessInfo.title"))),
            ]),
            _c("p", { staticClass: "settings-guide-description" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("accountTab.guide.businessInfo.description")) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "settings-online-links-guide" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm.$t("accountTab.guide.onlineLinks.title"))),
            ]),
            _c("p", { staticClass: "settings-guide-description" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("accountTab.guide.onlineLinks.description")) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "cards-holder" }, [
          _c(
            "div",
            { staticClass: "bb-card bb-settings-card mb-12 info-card" },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("span", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.$t("accountTab.companyDetailsCard.title"))),
                ]),
              ]),
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  { staticClass: "settings-business-info-mobile-guide" },
                  [
                    _c("h4", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("accountTab.guide.businessInfo.title")
                          ) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "settings-guide-description" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("accountTab.guide.businessInfo.description")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("accountTab.companyDetailsCard.nameInput.label")
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.name,
                        expression: "form.fields.name",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form.fields, "name", $event.target.value)
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.name,
                          expression: "form.errors.name",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.name) + " ")]
                  ),
                ]),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "accountTab.companyDetailsCard.organisationNumberInput.label"
                        )
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.organisationNumber,
                        expression: "form.fields.organisationNumber",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.organisationNumber },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form.fields,
                          "organisationNumber",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.organisationNumber,
                          expression: "form.errors.organisationNumber",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.form.errors.organisationNumber) + " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "accountTab.companyDetailsCard.addressInput.label"
                        )
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.address,
                        expression: "form.fields.address",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.address },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form.fields,
                          "address",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.address,
                          expression: "form.errors.address",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.address) + " ")]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center postal-city-inputs",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "bb-form-group mr-2",
                        staticStyle: { flex: "1" },
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accountTab.companyDetailsCard.postalNumberInput.label"
                              )
                            )
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.fields.postalNumber,
                              expression: "form.fields.postalNumber",
                            },
                          ],
                          staticClass: "bb-input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.form.fields.postalNumber },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form.fields,
                                "postalNumber",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.postalNumber,
                                expression: "form.errors.postalNumber",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.form.errors.postalNumber) + " "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bb-form-group ml-2",
                        staticStyle: { flex: "2" },
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accountTab.companyDetailsCard.cityInput.label"
                              )
                            )
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.fields.city,
                              expression: "form.fields.city",
                            },
                          ],
                          staticClass: "bb-input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.form.fields.city },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form.fields,
                                "city",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.form.errors.city,
                                expression: "form.errors.city",
                              },
                            ],
                            staticClass: "bb-invalid-feedback",
                          },
                          [_vm._v(" " + _vm._s(_vm.form.errors.city) + " ")]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("accountTab.companyDetailsCard.emailInput.label")
                      )
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.fields.email,
                        expression: "form.fields.email",
                      },
                    ],
                    staticClass: "bb-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.fields.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form.fields, "email", $event.target.value)
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.email,
                          expression: "form.errors.email",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.email) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "bb-card bb-settings-card mb-12 links-card" },
            [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  { staticClass: "settings-business-info-mobile-guide" },
                  [
                    _c("h4", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("accountTab.guide.onlineLinks.title")) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "settings-guide-description" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("accountTab.guide.onlineLinks.description")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("accountTab.onlineLinksCard.websiteInput.label")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "bb-input-group" }, [
                    _c("div", { staticClass: "input-icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-globe",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "#67768C",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "10" },
                          }),
                          _c("line", {
                            attrs: { x1: "2", y1: "12", x2: "22", y2: "12" },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.website,
                          expression: "form.fields.website",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.website },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "website",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.website,
                          expression: "form.errors.website",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.website) + " ")]
                  ),
                ]),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("accountTab.onlineLinksCard.fbPageInput.label")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "bb-input-group" }, [
                    _vm._m(0),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.facebookPage,
                          expression: "form.fields.facebookPage",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.facebookPage },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "facebookPage",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.facebookPage,
                          expression: "form.errors.facebookPage",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.facebookPage) + " ")]
                  ),
                ]),
                _c("div", { staticClass: "bb-form-group" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("accountTab.onlineLinksCard.igPageInput.label")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "bb-input-group" }, [
                    _vm._m(1),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fields.instagramPage,
                          expression: "form.fields.instagramPage",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.fields.instagramPage },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form.fields,
                            "instagramPage",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.errors.instagramPage,
                          expression: "form.errors.instagramPage",
                        },
                      ],
                      staticClass: "bb-invalid-feedback",
                    },
                    [_vm._v(" " + _vm._s(_vm.form.errors.instagramPage) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-end pt-6 save-btn-container",
            },
            [
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-success",
                  staticStyle: { "min-width": "130px" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("accountTab.saveBtn")) + " ")]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-icon" }, [
      _c("i", { staticClass: "fab fa-facebook-square" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-icon" }, [
      _c("i", { staticClass: "fab fa-instagram" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }